const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[8px] px-7 py-3.5 text-base font-medium hover:bg-[#e8463c] transition-colors";

export function FinalCTA() {
  return (
    <section
      data-testid="cc-final-cta-section"
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #FAFAF8 0%, #FFF1EE 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[52px] md:pt-[74px] pb-[64px] md:pb-[86px]">
        <div className="max-w-2xl mx-auto text-center reveal">
          <h2 className="font-display text-[32px] sm:text-[42px] lg:text-[54px] leading-[1.15] tracking-tight text-[#1C1917] mb-8">
            You don&rsquo;t have to figure out the whole path this week.
          </h2>
          <div className="space-y-2 mb-9">
            <p className="text-lg md:text-xl text-[#57534E] leading-relaxed">
              Come back to what matters.
            </p>
            <p className="text-lg md:text-xl text-[#57534E] leading-relaxed">
              Choose one honest next step.
            </p>
            <p className="font-display text-2xl md:text-3xl text-[#159E9A] leading-snug pt-2">
              Then return when it&rsquo;s time to choose again.
            </p>
          </div>
          <a
            href="mailto:lara@blueprint4joy.com?subject=Consistency%20Corner"
            data-testid="cc-final-cta-button"
            className={btnPrimary}
          >
            Join Consistency Corner
          </a>
        </div>
      </div>
    </section>
  );
}
